import Tooltip from "@insite/mobius/Tooltip";
import { css } from "styled-components";

(Tooltip as any).defaultProps = {
    typographyProps: {
        size: 13,
        lineHeight: "18px",
        css: css`
            display: block;
        `,
    },
    iconProps: {
        size: 18,
        color: "#000000",
        css: css`
            position: relative;
            top: 0.125em;
        `,
        src: "HelpCircle",
    },
};
